import { css, cx } from '@emotion/css';
import React from 'react';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {}

const defaultSelect = css({
  width: '100%',
  padding: 'var(--spacing-sm) var(--spacing-md)',
  fontSize: 'var(--fs-400)',
  fontFamily: 'inherit',
  color: 'var(--g-800)',
  backgroundColor: 'var(--primary-color)',
  border: '1px solid var(--pc-200)',
  borderRadius: 'var(--spacing-xs)',
  outline: 'none',
  transition: 'all 0.2s ease',
  appearance: 'none',
  backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 12px center',
  paddingRight: '40px',

  '&:focus': {
    borderColor: 'var(--pc-500)',
    boxShadow: '0 0 0 3px rgba(var(--pcrgba-200), 0.3)',
  },

  '&:disabled': {
    backgroundColor: 'var(--g-100)',
    cursor: 'not-allowed',
    opacity: 0.6,
  },
});

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, style, children, ...rest }, ref) => {
    return (
      <select
        ref={ref}
        className={cx(defaultSelect, className)}
        style={style}
        {...rest}
      >
        {children}
      </select>
    );
  }
);

Select.displayName = 'Select';

export default Select;
